import React, { useEffect, useState } from "react";
import "./scrollTopButton.scss";
import { useLocation } from "react-router-dom";
import { CommonConstants } from "@src/define/common";
import { useThrottle } from "@src/utils/hooks/useThrottle";

export default function ScrollTopButton() {
  const location = useLocation();
  const throttle = useThrottle();

  const [isScrollOver, setIsScrollOver] = useState(false);
  const [isIncludePath, setIsIncludePath] = useState(false);

  const { DisplayScrollTopButtonPaths } = CommonConstants;

  const handleScrollBtnClick = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleScroll = throttle(() => {
    window.scrollY > 300 ? setIsScrollOver(true) : setIsScrollOver(false);
  }, 50);

  useEffect(() => {
    const pathName = location.pathname;

    if (DisplayScrollTopButtonPaths.some((path) => pathName.startsWith(path))) {
      setIsIncludePath(true);
      window.addEventListener("scroll", handleScroll);
    } else {
      setIsIncludePath(false);
    }

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [location]);

  return (
    <>
      {isIncludePath && isScrollOver && (
        <button className="scroll-top-button-wrap" onClick={handleScrollBtnClick}>
          <i className="scroll-top-icon"></i>
        </button>
      )}
    </>
  );
}
